import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router'
import { AuthenticationService } from '../../core/_services/authentication.service';
import { AlertasService } from '../../core/_services/alerta.service';
import { CoreService } from '../../core/_services/core.services';

@Component({
  selector: 'app-verificar-cambio',
  templateUrl: './app.verificar-cambio.component.html',
})
export class AppVerificarCambioComponent implements OnInit {

  token: any;
  mensaje: any;
  titulo: any;

  constructor(
    private route: ActivatedRoute,
    private service: AuthenticationService,
    public msj: AlertasService,
    public coreService: CoreService,
  ) { }

  ngOnInit(): void {
    this.token = this.route.snapshot.paramMap.get('token');
    this.coreService.get('/confirmar-cambio-correo?token=' + this.token).subscribe(
      (res: any) => {
        this.mensaje = res.mensaje;
        this.titulo = res.titulo;
      },
      (err: any) => {
        console.log(err);
      }
    )
  }

}
